import { render, staticRenderFns } from "./FilterPosting.vue?vue&type=template&id=315ef017&"
import script from "./FilterPosting.vue?vue&type=script&lang=js&"
export * from "./FilterPosting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports